// Vocabulario compartido por el listado y el detalle del log de mails.

// SKIPPED no es un fallo: es un envío que a propósito no se hizo (sin dirección, o con una
// dirección que no puede serlo). Pintarlo de rojo junto a los que fallaron asusta sin motivo.
// Mismo criterio que la pantalla de Salud del sistema.
export function badgeEstado(estado) {
    const e = String(estado || '').toUpperCase();
    if (e === 'SENT') return 'badge-success';
    if (e === 'SKIPPED') return 'badge-secondary';
    return 'badge-danger';
}

export function textoEstado(estado) {
    const e = String(estado || '').toUpperCase();
    if (e === 'SENT') return 'Enviado';
    if (e === 'SKIPPED') return 'No enviado';
    if (e === 'FAILED') return 'Falló';
    return e || '—';
}

// El `template_key` es una clave técnica y el listado lo lee un humano. Las que no están acá
// se muestran tal cual en vez de inventarles un nombre: es preferible ver `purchase_copy.x`
// que un "Otro" que esconde de qué mail se trata.
const NOMBRES = {
    purchase_confirmation: 'Confirmación de compra',
    invoice: 'Factura',
    contact: 'Contacto',
    admin_welcome: 'Alta de administrador',
};

export function nombreTipo(templateKey) {
    if (!templateKey) return 'Sin plantilla';
    return NOMBRES[templateKey] || templateKey;
}

// La referencia como texto legible. NO se linkea: el detalle de una compra en el backoffice es
// un modal dentro de /purchase, no una ruta propia, así que no hay a dónde navegar. Antes que
// un link que no lleva a ningún lado, el número: alcanza para buscarla en la pantalla de ventas.
const REFERENCIAS = {
    purchase: 'Compra',
    invoice: 'Factura',
    contact: 'Contacto',
    envio_gratis_regalado: 'Envío gratis regalado',
};

export function textoReferencia(referenceType, referenceId) {
    if (!referenceType && !referenceId) return '—';
    const nombre = REFERENCIAS[referenceType] || referenceType || 'Referencia';
    return referenceId ? `${nombre} ${referenceId}` : nombre;
}

export function textoAdjunto(a) {
    const kb = a && a.bytes != null ? ` · ${Math.max(1, Math.round(a.bytes / 1024))} KB` : '';
    return `${(a && a.filename) || 'adjunto'}${kb}`;
}
